/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Hledali jsme všude, ale tato položka neexistuje. Mohla být odstraněna. Pokud ovšem nemáte překlep v adrese URL.',
  'embedded-confluence-common.src.content.empty-state-header': 'Nemůžeme najít, co hledáte',
  'embedded.confluence.already-logged-in-paragraph': 'Jste již přihlášeni? Zkuste obnovit stránku.',
  'embedded.confluence.footer.hover.text': 'Zobrazit v Confluence',
  'embedded.confluence.footer.prefix': 'Používá technologii',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Přihlaste se do Confluence',
  'embedded.confluence.login-page.login-button': 'Přihlásit se do Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Tlačítko přihlášení',
  'embedded.confluence.login-page.login-text': 'Chcete-li zobrazit tuto stránku, musíte být přihlášeni.',
  'embedded.confluence.login-page.refresh-page-banner':
    'Po přihlášení by se tato stránka měla automaticky obnovit. Pokud ne, můžete ji obnovit kliknutím zde.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Obnovit stránku',
  'embedded.confluence.need-to-log-in-paragraph': 'Chcete-li zobrazit tuto stránku, musíte být přihlášeni.',
  'embedded.confluence.still-having-trouble-paragraph':
    'Pořád máte potíže? Ujistěte se, že jsou povoleny soubory cookies třetích stran, nebo {link}',
  'embedded.confluence.troubleshooting-link-text': 'se podívejte se do průvodce řešením problémů.',
  'embedded.confluence.troubleshooting-link.aria-label': 'odkaz na průvodce řešením problémů',
};
